import { useMutation } from '@tanstack/react-query'

import { AxiosError } from 'axios'
import {
  CancelDigitalSignatureProcessClientRequest,
  CancelDigitalSignatureProcessClientResponse,
} from '../../@types/CancelDigitalSignatureProcess'
import { ErrorHandling } from '../../@types/ErrorHandling'
import { FirstReceiptInfo } from '../../@types/digitalSignature/RefreshDigitalSignatureStatus'
import { api } from '../../Services/API'
import { usePaymentConfirmationStore } from '../../Stores/paymentConfirmationStore'
import { useCancelDigitalSignatureProcessStore } from '../../Stores/useCancelDigitalSignatureProcessStore'
import { useFirstReceiptInfo } from '../../Stores/useFirstReceiptInfo'
import { API_ROUTES } from '../../constants/apiRoutes'
import { useErrorRequest } from '../useErrorRequest'

const request = async (payload: CancelDigitalSignatureProcessClientRequest) => {
  const { data } = await api.post<CancelDigitalSignatureProcessClientResponse>(
    API_ROUTES.cancelDigitalSignatureProcess,
    payload,
  )

  return data
}

export const useCancelDigitalSignatureProcess = () => {
  const { setCancelDigitalSignatureProcess } =
    useCancelDigitalSignatureProcessStore()
  const { setIsSignatureDigital } = usePaymentConfirmationStore()
  const { setFirstReceiptInfo } = useFirstReceiptInfo()
  const { handleErrorRequest } = useErrorRequest()

  return useMutation({
    mutationFn: (payload: CancelDigitalSignatureProcessClientRequest) =>
      request(payload),
    onSuccess: (data) => {
      setCancelDigitalSignatureProcess(data)
      setFirstReceiptInfo(data.firstReceiptInfo as FirstReceiptInfo)
      setIsSignatureDigital(false)
    },
    onError: (error: AxiosError<ErrorHandling[]>) => {
      handleErrorRequest({ error })
    },
  })
}
